export function formatYen(amount: number) {
  return `¥${amount.toLocaleString()}`;
}
